<script>
import headBox from "@/components/head.vue"
import footBox from "@/components/foot.vue"
import {getText} from "@/utils/text";

export default {
  components: {headBox, footBox},
  data() {
    return {}
  },
  mounted() {
    //滚动到顶部
    window.scrollTo(0, 0)

  },
  methods: {
    getViewText(key) {
      return getText(key)
    }
  }
}
</script>


<template>
  <div>
    <headBox/>

    <section id="content" lang=ZH-CN style='tab-interval:21.0pt;word-wrap:break-word;text-justify-trim:
        punctuation'>

      <div :class="$store.state.isPhone?'WordSection':'WordSection1'" style='layout-grid:15.6pt'>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US style='font-size:16.0pt;line-height:
        200%;font-family:"Meiryo",sans-serif'>{{ getViewText('privacy_policy') }}}</span></b><span lang=EN-US style='font-family:"Meiryo",sans-serif;
        '><o:p></o:p></span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_1') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l3 level1 lfo2'><![if !supportLists]><b><span lang=EN-US
                                                                    style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:Meiryo'><span style='mso-list:Ignore'>1.<span
          style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span></b><![endif]><b><span
          lang=EN-US
          style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('information_we_collect')
          }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US
                                        style='font-family:"Meiryo",sans-serif'>1.1 {{
            getViewText('personal_information')
          }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_2') }}</span>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US
                                        style='font-family:"Meiryo",sans-serif'>1.2 {{
            getViewText('usage_data')
          }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_3') }}</span>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><b><span lang=EN-US
                                        style='font-family:"Meiryo",sans-serif'>1.3 {{
            getViewText('cookies_and_similar_technologies')
          }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_4') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l3 level1 lfo2'><![if !supportLists]><b><span lang=EN-US
                                                                    style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:Meiryo'><span style='mso-list:Ignore'>2.<span
          style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span></b><![endif]><b><span
          lang=EN-US
          style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('p_5') }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_6') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_7') }}</span></p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_8') }}</span></p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_9') }}</span></p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>iv.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_10') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>v.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_11') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>vi.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_12') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l2 level1 lfo4'><![if !supportLists]><span lang=EN-US
                                                                 style='font-family:"Meiryo",sans-serif;mso-bidi-font-family:Meiryo'><span
          style='mso-list:Ignore'>vii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
        </span></span></span><![endif]><span lang=EN-US
                                             style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_13') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l3 level1 lfo2'><![if !supportLists]><b><span lang=EN-US
                                                                    style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:Meiryo'><span style='mso-list:Ignore'>3.<span
          style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span></b><![endif]><b><span
          lang=EN-US
          style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('security') }}<o:p></o:p></span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_14') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l3 level1 lfo2'><![if !supportLists]><b><span lang=EN-US
                                                                    style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:Meiryo'><span style='mso-list:Ignore'>4.<span
          style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span></b><![endif]><b><span
          lang=EN-US
          style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('children_privacy')
          }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_15') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l3 level1 lfo2'><![if !supportLists]><b><span lang=EN-US
                                                                    style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:Meiryo'><span style='mso-list:Ignore'>5.<span
          style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span></b><![endif]><b><span
          lang=EN-US
          style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('p_16') }}</span></b>
        </p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_17') }}</span>
        </p>

        <p class=MsoListParagraph align=left style='margin-top:15.6pt;margin-bottom:15.6pt;
        text-align:left;mso-char-indent-count:0;line-height:
        200%;mso-list:l3 level1 lfo2'><![if !supportLists]><b><span lang=EN-US
                                                                    style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
        mso-bidi-font-family:Meiryo'><span style='mso-list:Ignore'>6.<span
          style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span></b><![endif]><b><span
          lang=EN-US style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('contact_us')}}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
        margin-bottom:15.6pt;text-align:
        left;line-height:200%'><span lang=EN-US style='font-family:"Meiryo",sans-serif'>{{ getViewText('p_18')}}</span></p>

      </div>

    </section>


    <footBox/>
  </div>
</template>
<style>
.WordSection1 {
  margin-left: 105.0pt;
  margin-right: 105.0pt;
  color: #fff
}

.WordSection {
  margin-left: 50px;
  margin-right: 50px;
  color: #fff
}
</style>



// WEBPACK FOOTER //
// src/views/privacypolicy.vue